<template>
    <radio-button-field
        v-bind="$props"
        @update:model-value="select($event)"
    />
</template>

<script>
import AbstractField from '@/views/order/lenses/fields/AbstractField.vue';
import RadioButtonField from '@/views/order/lenses/fields/RadioButtonField.vue';
import useDesignLevelComposable from '@/composables/DesignLevelComposable';

export default
{
    name: 'DesignLevel',

    components:
    {
        RadioButtonField,
    },

    extends: AbstractField,

    emits: ['update:modelValue'],

    setup(props, { emit })
    {
        const {
            select,
        } = useDesignLevelComposable(props, emit);

        return {
            select,
        };
    },
};
</script>

<style lang="scss" scoped>
</style>
